export const environment = {
  production: true,
  API_URL: 'https://api.porozmawiaj.my',
  STATICS_URL: 'https://static.porozmawiaj.my/',
  AUTH_URL: 'https://api.porozmawiaj.my/auth/oauth/token',
  CLIENT_ID: 'y5u4GGz2ee7SX37M',
  CLIENT_SECRET:
    'VFQJGZS4eQ3cG6SnUchU4zPEekWBrmSgkPQ7m7f8J2ZgqFTS4DxEt9Pfc6KYHxGc',
  SCOPE: 'health',
  GRANT_TYPE: 'password',
  EVENT_SOURCE_URL: 'https://powiadomienia.porozmawiaj.my',
  GRECAPTCHA_SITE_KEY: '6LeFHtQrAAAAAJ30XFU4-LcchH8iz3CeL1qj_-Ct',
  GRECAPTCHA_ENABLED: true,
  MATOMO_URL: 'https://stats.porozmawiaj.my/',
  MATOMO_SITE_ID: 1,
  TIK_TOK_ENABLED: true,
};

(environment as any).TAC_LINK =
  environment.STATICS_URL + 'policies/tac/2026-03-01/{language}.html';
(environment as any).M_LINK =
  environment.STATICS_URL + 'policies/m/2025-10-07/{language}.html';
(environment as any).PP_LINK =
  environment.STATICS_URL + 'policies/pp/2026-03-01/{language}.html';
(environment as any).CC_LINK =
  environment.STATICS_URL + 'policies/cc/2025-10-07/{language}.html';
